export default __webpack_public_path__ + "static/media/setReadingGoal@2x.df0b40d5.png";